/* global ywcas_search_results_block_parameter */
import React from 'react';
import parse from 'html-react-parser';
import {useState} from '@wordpress/element';
import {Stack, Typography, Spinner, Box} from '@lapilli-ui/components';
import {Button} from '@wordpress/components';

import {getPrice, getWordStr, isEmpty,useMediaQuery} from '../../utils/functions';
import {YWCAS_ADD_TO_CART_LABEL, YWCAS_AJAX_URL, YWCAS_IN_STOCK_LABEL, YWCAS_OUT_OF_STOCK_LABEL, YWCAS_READ_MORE, YWCAS_SELECT_OPTIONS, YWCAS_SKU_LABEL} from '../../../config';
import ItemThumb from './item-thumb';

function ResultItem(props) {
  const {
    item, searchQuery, onClick, showName, showImage, showPrice, showCategories, showStock, showSKU,
    showSummary, showAddToCart, layout, imageSize, imagePosition, summaryMaxWord, productNameColor, priceLabel, categoryResults, results,
  } = props;

  const isSmallDevice = useMediaQuery('(max-width: 600px)');

  const stackDirection = layout === 'grid' ? 'column' : 'row';
  const stackAlign = 'center';
  const marginLeft = ('list' === layout && imagePosition === 'right') ? 'auto' : 0;
  const [addingToCart, setAddingToCart] = useState(false);

  const findMainCategory = ( itemCategory ) =>{
    let parentCat = categoryResults.find(singleCat => parseInt(singleCat.term_id) === itemCategory.parent );
    if( parentCat && parentCat.parent !== 0){
      parentCat = findMainCategory(parentCat);
    }
    return parentCat;
  }

  const getCategoryLink = ( category ) =>{
    const categoryLabel = category.name;

    return(
        <a href={category.url}>{parse(categoryLabel)}</a>
    )
  }

  const ItemCategory = categories => {
    if (categoryResults) {
      const itemCategory = categoryResults.find(singleCat => parseInt(singleCat.term_id) === categories[0]);
      if( !itemCategory ){
        return '';
      }
      const parentCategory = itemCategory.parent !== 0 ? findMainCategory(itemCategory) : false;
      if( parentCategory ){
        return(
            <Box>
              {getCategoryLink(parentCategory)} <span> > </span>  {getCategoryLink(itemCategory)}
            </Box>
        )

      }else{
        return getCategoryLink(itemCategory);
      }
    }
    return '';
  };

  const ItemAddToCart = () => {
    const instock = parseInt(item.instock);
    const is_purchasable = parseInt(item.is_purchasable);
    const classButton = 'wp-element-button wp-block-button__link wp-block-woocommerce-product-button search-result-add-to-cart';
    if (is_purchasable && instock && (item.product_type === 'simple' || item.product_type === 'variation') && 0 < parseFloat(item?.max_price)) {
      return <Button className={classButton} onClick={addToCart}>{YWCAS_ADD_TO_CART_LABEL}</Button>;
    }
    if (instock && item.product_type === 'variable' && 0 < parseFloat(item?.max_price)) {
      return <Button size="sm" className={classButton} onClick={(e) => onClick(e, item)}>{YWCAS_SELECT_OPTIONS}</Button>;
    }
    return <Button size="sm" className={classButton} onClick={(e) => onClick(e, item)}>{YWCAS_READ_MORE}</Button>;
  };

  const addToCart = (e) => {
    e.stopPropagation();
    if (!e.target.classList.contains('search-result-add-to-cart')) {
      return;
    }
    onClick(e, item, false);
    setAddingToCart(true);
    jQuery.ajax({
      url: YWCAS_AJAX_URL.toString().replace('%%endpoint%%', 'add_to_cart'),
      data: {quantity: 1, product_id: item.post_id, product_sku: item.sku},
      type: 'POST',
      success: function(response) {
        setAddingToCart(false);
      },
    });
  };

  const ItemName = () => {
    if (!showImage && isEmpty(item.thumbnail)) {
      return '';
    }
    const classStock = parseInt(item.instock) > 0 ? 'in-stock' : 'out-of-stock';
    return (
        <Stack className="search-result-item_name" sx={{flex: 1, alignItems: 'left'}} onClick={(e) => onClick(e, item, results.totalResults)}>
          {showName && <Typography sx={{color: productNameColor, fontSize: '0.9em'}} className="search-result-item__name" >{parse(item.name)}</Typography>}
          {showPrice && <Typography className="search-result-item__price" sx={{fontSize: '0.9em', fontWeight: '600'}}>{priceLabel} {getPrice(item)}</Typography>}

          <Box className="search-result-item__inline_group" direction="row" sx={{display: 'block'}}>
            {showSKU && <Typography className={`search-result-item__sku`}><strong>{YWCAS_SKU_LABEL}</strong> {item.sku}</Typography>}
            {showSKU && showStock && <span>-</span>}
            {showStock && <Typography className={`search-result-item__stock stock ${classStock}`}>{parseInt(item.instock) ? YWCAS_IN_STOCK_LABEL : YWCAS_OUT_OF_STOCK_LABEL}</Typography>}
          </Box>

          {showCategories && <Box className="search-result-item__category" sx={{fontSize: '0.7em'}}>{ItemCategory(item.parent_category)}</Box>}

          {showSummary && 'grid'=== layout && <Typography className="search-result-item__summary" sx={{fontSize: '0.8em'}}>{getWordStr(item.summary, summaryMaxWord)}</Typography>}
        </Stack>
    );
  };

  return (
      <Box className={`search-result-item ${layout}`}>
      <Stack align={stackAlign} direction={stackDirection} spacing={2} className={`search-result-item__content`} data-id={item.post_id} data-name={item.name} onClick={(e) => onClick(e, item)}>
        {showImage && (layout === 'grid' || (layout === 'list' && imagePosition !== 'right')) && <ItemThumb marginLeft={marginLeft} item={item} {...props}/>}
        <ItemName/>
        {isSmallDevice && showSummary && 'grid'!== layout && <Typography className="search-result-item__summary" sx={{fontSize: '0.8em'}}>{parse(getWordStr(item.summary, summaryMaxWord))}</Typography>}
        {showAddToCart && (!addingToCart ? <div className="wp-block-button"><ItemAddToCart/></div> : <Spinner color="default" size="sm" thickness={3.6}/>)}
        {showImage && layout === 'list' && imagePosition === 'right' && <ItemThumb marginLeft={marginLeft} item={item} {...props} />}

      </Stack>
        {!isSmallDevice && showSummary && 'grid'!== layout && <Typography className="search-result-item__summary" sx={{fontSize: '0.8em'}}>{parse(getWordStr(item.summary, summaryMaxWord))}</Typography>}
      </Box>
  );
}

export default ResultItem;